module.exports = __webpack_public_path__ + "static/ford-e6f8d9e2c0a3e1763e3a608a128898be.jpg";